<template>
  <div>
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="">
        <div class="columns is-variable is-1 mb-0">
          <!-- treatment -->
          <div class="column is-2">
            <ValidationProvider
              name="doctor_treatment"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Dr./Dra."
                label-position="on-border"
                class="is-fullwidth"
              >
                <b-select v-model="doctor.treatment">
                  <option value="Dr.">Dr.</option>
                  <option value="Dra.">Dra.</option>
                </b-select>
              </b-field>
            </ValidationProvider>
          </div>
          <!-- name -->
          <div class="column is-4">
            <ValidationProvider
              name="doctor_name"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Nome"
                label-position="on-border"
              >
                <b-input v-model="doctor.name" type="text"></b-input>
              </b-field>
            </ValidationProvider>
          </div>
          <!-- cpf -->
          <div class="column is-3">
            <ValidationProvider
              name="doctor_cpf"
              rules="required|cpf|uniqueCpf"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :message="errors[0]"
                label="Cpf"
                label-position="on-border"
              >
                <b-input
                  :disabled="doctor._id"
                  v-model="doctor.cpf"
                  v-mask="'###.###.###-##'"
                  type="text"
                ></b-input>
              </b-field>
            </ValidationProvider>
          </div>
          <!-- email -->
          <div class="column is-3">
            <ValidationProvider
              name="doctor_email"
              rules="required|email|uniqueEmail"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :message="errors[0]"
                label="Email"
                label-position="on-border"
              >
                <b-input v-model="doctor.email" type="text"></b-input>
              </b-field>
            </ValidationProvider>
          </div>
        </div>

        <div class="columns is-variable is-1 mb-0">
          <!-- cbo -->
          <div class="column is-6">
            <ValidationProvider
              name="doctor_cbo"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Especialidade"
                label-position="on-border"
              >
                <b-taginput
                  v-model="doctor.cbos"
                  :data="cbos"
                  field="name"
                  autocomplete
                  icon="label"
                  placeholder="Código ou nome..."
                  @typing="getAsyncData"
                >
                </b-taginput>
              </b-field>
            </ValidationProvider>
          </div>
          <!-- council_type -->
          <div class="column is-3">
            <ValidationProvider
              name="doctor_council_type"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Conselho"
                label-position="on-border"
              >
                <SelectCouncil
                  v-model="doctor.council.type"
                  :initialValue="doctor.council.type"
                  :status="true"
                  @selectedCouncil="(v) => $set(doctor.council, 'type', v)"
                />
              </b-field>
            </ValidationProvider>
          </div>
          <!-- council_number -->
          <div class="column is-3">
            <ValidationProvider
              name="doctor_council_number"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Cons. N."
                label-position="on-border"
              >
                <b-input v-model="doctor.council.number" type="text"></b-input>
              </b-field>
            </ValidationProvider>
          </div>
        </div>
        <!-- https://vee-validate.logaretm.com/v3/advanced/cross-field-validation.html#targeting-other-fields -->
        <div class="columns is-variable is-1 mb-0">
          <!-- zip office -->
          <!-- <div class="column is-4">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-field
              :type="errors[0] ? 'is-danger' : ''"
              :message="errors[0]"
              label="zip"
              label-position="on-border"
            >
              <b-input
                v-on:keyup.native="getAddress"
                v-model="office.address.zip"
                v-mask="'##.###-###'"
                type="text"
              ></b-input>
            </b-field>
          </ValidationProvider>
        </div> -->
          <!-- password -->
          <div class="column is-4">
            <ValidationProvider
              rules="required|password:@passwordConfirm"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :message="errors[0]"
                label="Senha"
                label-position="on-border"
              >
                <b-input v-model="doctor.password" type="password"></b-input>
              </b-field>
            </ValidationProvider>
          </div>
          <!-- confirm password -->
          <div class="column is-4">
            <ValidationProvider
              name="passwordConfirm"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                label="Confirme sua senha"
                label-position="on-border"
              >
                <b-input v-model="passwordConfirm" type="password"></b-input>
              </b-field>
            </ValidationProvider>
          </div>
          <div class="column"></div>
        </div>

        <ValidationProvider name="terms" rules="required" v-slot="{ errors }">
          <b-field :type="errors[0] ? 'is-danger' : ''">
            <b-checkbox
              v-model="terms"
              type="is-info"
              true-value="y"
              false-value=""
              >Aceito a
              <a
                href="https://docs.google.com/document/d/1OVyBkJo7e2ugh05Utl86kNSlNGQgi1RcbAqLefwxtss/edit?usp=sharing"
                target="_blanck"
                >política de privacidade</a
              >
            </b-checkbox>
          </b-field>
        </ValidationProvider>

        <!-- Button -->
        <div class="buttons">
          <b-button
            :disabled="invalid"
            @click="sing('starter')"
            type="is-info"
            size="is-large"
            expanded
            >Assinar por R$ 67,00/mês</b-button
          >
          <!-- <b-button
          :disabled="invalid"
          @click="sing('try')"
          type="is-text"
          expanded
          >Experimentar Grátis por 3 Meses</b-button
        > -->
        </div>
      </form>
    </ValidationObserver>
    <p>
      Garantia incondicional: Se em até três meses de uso do sistema, você não
      estiver completamente satisfeito, devolveremos todas as mensalidades
      pagas.
    </p>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import { mask } from "vue-the-mask";
//import moment from "moment-timezone";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import SelectCouncil from "@/components/SelectCouncil.vue";
extend("required", {
  ...required,
  message: "Esse campo é requerido",
});
extend("email", {
  ...email,
  message: "Email inválido",
});
extend("cpf", {
  validate: (cpf) => {
    if (typeof cpf !== "string") return false;
    cpf = cpf.replace(/[\s.-]*/gim, "");
    if (
      !cpf ||
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    ) {
      return false;
    }
    let sum = 0;
    let rest;
    for (let i = 1; i <= 9; i++)
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) rest = 0;
    if (rest != parseInt(cpf.substring(9, 10))) return false;
    sum = 0;
    for (let i = 1; i <= 10; i++)
      sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) rest = 0;
    if (rest != parseInt(cpf.substring(10, 11))) return false;
    return true;
  },
  message: "Cpf inválido",
});
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Senhas não coicidem",
});
export default {
  name: "DoctorForm",
  directives: { mask },
  components: {
    ValidationProvider,
    ValidationObserver,
    SelectCouncil,
  },
  data() {
    return {
      doctor: { council: {} },
      office: { address: {} },
      cbos: [],
      passwordConfirm: "",
      terms: "",
    };
  },
  computed: {
    plan: function () {
      return this.$route.params.plan;
    },
    //tzNames: () => moment.tz.names(),
  },
  mounted() {
    extend("uniqueEmail", {
      validate: (email) => {
        if (this.doctor._id) return true;
        return this.$http
          .post(`doctor/exist/email`, { value: email }, { useCache: true })
          .then((response) => {
            return !response.data;
          });
      },
      message: 'Email já cadastrado. Clique em "JÁ TENHO CONTA" acima',
    });

    extend("uniqueCpf", {
      validate: (cpf) => {
        if (this.doctor._id) return true;
        cpf = cpf.replace(/\D/g, "");
        return this.$http
          .post(`doctor/exist/cpf`, { value: cpf }, { useCache: true })
          .then((response) => {
            return !response.data;
          });
      },
      message: 'Cpf já cadastrado. Clique em "JÁ TENHO CONTA" acima',
    });
  },
  created() {},
  methods: {
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        let data = {
          doctor: this.doctor,
          office: this.office,
        };
        this.$http.post(`doctor`, data).then(() => {
          this.$router.push(`/account/thanks/${this.doctor.plan}`);
        });

        // Resetting Values
        //doctor = {};

        // Wait until the models are updated in the UI
        // this.$nextTick(() => {
        //   this.$refs.form.reset();
        // });
      });
    },
    sing(plan) {
      this.doctor.plan = plan;
      this.onSubmit();
    },
    getAsyncData: debounce(function (q) {
      if (!q.length || q.length < 5) {
        this.data = [];
        return;
      }
      this.isFetching = true;
      this.$http.get(`tb_cbo/search/${q}`).then((response) => {
        this.cbos = response.data;
        this.isFetching = false;
      });
    }, 500),
    // getAddress: function () {
    //   this.foundAddress = false;
    //   if (/^[0-9]{2}\.[0-9]{3}-[0-9]{3}$/.test(this.office.address.zip)) {
    //     let zip = this.office.address.zip.replace(/\D/g, "");
    //     this.$http
    //       .get(`https://viacep.com.br/ws/${zip}/json`)
    //       .then((response) => {
    //         if (response.erro) {
    //           this.address = {};
    //           this.foundAddress = false;
    //           return;
    //         }
    //         this.office.address = Object.assign(this.office.address, {
    //           street: response.data.logradouro,
    //           neighborhood: response.data.bairro,
    //           city: response.data.localidade,
    //           state: response.data.uf,
    //         });
    //         let regex = RegExp("(" + response.data.localidade + ")", "gi");
    //         this.office.tz =
    //           this.tzNames.find((value) => regex.test(value)) || "undefined";
    //         this.foundAddress = true;
    //       });
    //   }
    // },
  },
};
</script>

